import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { colors, radii } from '../theme/tokens';
import { NAV, GROUP_ORDER } from '../menu';
import type { NavGroup, NavItem } from '../menu';
import { selectActiveModules } from '../redux/session/session.selectors';

const NavButton: React.FC<{ item: NavItem; active: boolean; onClick: () => void }> = ({
  item,
  active,
  onClick,
}) => {
  const [hover, setHover] = React.useState(false);
  const bg = active
    ? 'rgba(247,244,236,.14)'
    : hover
      ? 'rgba(247,244,236,.10)'
      : 'transparent';
  const fg = active || hover ? colors.cream : 'rgba(247,244,236,.72)';
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        width: '100%',
        textAlign: 'left',
        padding: '9px 12px',
        borderRadius: radii.button,
        fontSize: 13,
        fontWeight: active ? 600 : 400,
        background: bg,
        color: fg,
        border: 'none',
        cursor: 'pointer',
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: 2,
          background: active ? colors.goldLight : 'transparent',
          flex: 'none',
        }}
      />
      {item.text}
    </button>
  );
};

/* §2.2 Left sidebar (236px) — 5 groups, per-role module filtering. */
export const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const modules = useSelector(selectActiveModules);

  return (
    <nav style={{ background: colors.deepGreen, padding: '14px 10px', overflowY: 'auto' }}>
      {GROUP_ORDER.map((group: NavGroup) => {
        const items = NAV.filter((n) => n.group === group && modules.includes(n.id));
        if (items.length === 0) return null;
        return (
          <div key={group} style={{ marginBottom: 14 }}>
            <div
              style={{
                fontSize: 10.5,
                letterSpacing: '.14em',
                textTransform: 'uppercase',
                color: 'rgba(216,183,91,.85)',
                padding: '6px 12px',
              }}
            >
              {group}
            </div>
            {items.map((item) => (
              <NavButton
                // Two Inspect entries share the module id, so the path is the key.
                key={item.path}
                item={item}
                active={
                  location.pathname === item.path ||
                  // Every step under the workspace keeps "Current Inspection" lit.
                  (item.path === '/inspect/checklist' &&
                    location.pathname.startsWith('/inspect/') &&
                    location.pathname !== '/inspect/start')
                }
                onClick={() => navigate(item.path)}
              />
            ))}
          </div>
        );
      })}
    </nav>
  );
};

export default Sidebar;
